import { InjectionToken, Signal } from '@angular/core'
import { Observable, Subject } from 'rxjs'
import { DialogParams } from './notification.model'
import { File as ApiFile } from '../modules/files/models/file.entity'

/**
 * Modal params
 */
export interface ModalParams<ComponentType> {
  component: any
  modalClass?: string
  initialState?: Partial<ComponentType>
}

/**
 * Modal reference
 */
export interface ModalRef<ModalResponseType = any> {
  ref: any
  subject: Subject<ModalResponseType | undefined>
}

/**
 * Modal alert management
 */

export type ModalAlertType = 'error' | 'info' | 'success'

export interface ModalAlert {
  visible: boolean
  type: ModalAlertType
  text: string
}

/**
 * Actions
 */
export interface ModalAction {
  type: string
  files?: ApiFile[]
}

/**
 * Modal info
 */
export interface ModalInfo {
  icon?: string
  label?: string
  explain?: string
  text: string
}

/**
 * Modal manager base structure
 */
export declare interface ModalManager {
  show$: <ComponentType, ModalResponseType = any>(
    params: ModalParams<ComponentType>,
  ) => Observable<ModalResponseType | undefined>
  showDialog$: (
    params: DialogParams,
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  ) => Observable<boolean>
  hide: <ModalResponseType = any>(
    modalId: string,
    response?: ModalResponseType,
  ) => void
  hideAll: () => void
}

export const MODAL_MANAGER = new InjectionToken<ModalManager>('ModalManager')

/***
 * Modal component base structure
 */
export declare interface ModalComponent {
  modalId: string
  title?: string
}

/* export interface ModalOptions<TComponent = object> {
  component: Type<TComponent>
  initialState?: Partial<TComponent>
}
 */
export interface DialogOptions {
  title?: string
  titleParams?: Array<string | number>
  message?: string
  messageParams?: Array<string | number>
  template?: string
  buttons?: ModalButtonLabel[]
}

export type ModalButtonLabel =
  | 'Ok'
  | 'Save'
  | 'Confirm'
  | 'Cancel'
  | 'Open'
  | 'Continue'

/**
 * NgModalService interface for the new modal system
 */
export type ModalResponse = 'success' | 'cancel' | 'closed' | 'alternative'

export abstract class NgModalServiceInterface {
  abstract showDialog(options: DialogOptions): Promise<ModalResponse>
  abstract respond(value: ModalResponse): void
  abstract dialogConfig: Signal<DialogOptions | null>
  abstract response: Signal<ModalResponse | null>
}
